// cashTransactions.styles.ts
export const styles = {
  container: {
    mt: 1,
    mb: 4,
    height: 'calc(100vh - 250px)',
    display: 'flex',
    flexDirection: 'column'
  },
  headerBox: {
    mb: 1
  },
  title: {
    color: '#ffffff',
    mb: 1
  },
  contentBox: {
    flex: 1,
    overflow: 'auto',
    pt: 1,
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#1e1e1e',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#555',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#777',
    },
  },
  filterContainer: {
    mb: 2,
    display: 'flex',
    gap: 2,
    alignItems: 'flex-start',
    minHeight: '130px',
  },
  customSelect: {
    height: 50,
    color: '#ffffff',
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: '#555',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#777',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1976d2',
    },
    '.MuiSvgIcon-root': {
      color: '#ffffff',
    },
  },
  formBox: {
    p: 2,
    display: 'flex',
    alignItems: 'left',
    gap: 2,
    flexDirection: 'column',
    bgcolor: '#2a2a2a',
    borderRadius: 2,
    ml: 'auto',
    mr: 0.5
  },
  totalAmountText: {
    color: '#ffffff',
    fontWeight: 'bold',
    textAlign: 'left'
  },
  formFieldsBox: {
    display: 'flex',
    gap: 2,
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  dateTimePicker: {
    width: 200,
    '& .MuiInputBase-input': { color: '#ffffff' },
    '& .MuiInputLabel-root': { color: '#ffffff' },
    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' },
    '& .MuiSvgIcon-root': { color: '#ffffff' },
  },
  textField: {
    width: 160,
    '& .MuiInputBase-input': { color: '#ffffff' },
    '& .MuiInputLabel-root': { color: '#ffffff' },
    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#777' },
  },
  submitButton: {
    height: 40,
    backgroundColor: '#1976d2',
    '&:hover': { backgroundColor: '#1565c0' },
    '&:disabled': { backgroundColor: '#555', color: '#999' },
    whiteSpace: 'nowrap',
  },
  tableContainer: {
    backgroundColor: '#1e1e1e',
    maxHeight: 'calc(100vh - 400px)',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#1e1e1e',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#555',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#777',
    },
  },
  tableCell: {
    color: '#ffffff'
  },
  tableCellWithWidth: (width: string) => ({
    color: '#ffffff',
    width: width
  }),
  checkbox: {
    color: '#ffffff'
  },
  selectMenuPaper: {
    maxHeight: 200,
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  },
};